import { getApi, postApi } from "../helpers/auth_helpers";

const base = process.env.REACT_APP_SERVERURL || "";

export const listStudioAccessRequests = () =>
  getApi(`${base}/studio/collector-access-requests`);

export const shareStudioAccessRequest = (id: string) =>
  postApi(`${base}/studio/collector-access-requests/${id}/share`, {});

export const declineStudioAccessRequest = (id: string) =>
  postApi(`${base}/studio/collector-access-requests/${id}/decline`, {});

export const startStudioAccessTransfer = (id: string) =>
  postApi(`${base}/studio/collector-access-requests/${id}/start-transfer`, {});

export const listStudioOwnershipClaims = (status = "PENDING") =>
  getApi(`${base}/studio/collector-ownership-claims?status=${encodeURIComponent(status)}`);

export const approveStudioOwnershipClaim = (id: string) =>
  postApi(`${base}/studio/collector-ownership-claims/${id}/approve`, {});

export const rejectStudioOwnershipClaim = (id: string, reason: string) =>
  postApi(`${base}/studio/collector-ownership-claims/${id}/reject`, { reason });
